import { useEffect, useState } from 'react'

import { useCreateAddressValidationSchema } from '@dhl/input-address'

const INITIAL_COUNTRY_CODE = 'NL'
const CARRIER = 'parcel'

export const useAddressService = (countryCodeState: string | undefined) => {
  const [countryCode, setCountryCode] = useState(countryCodeState || INITIAL_COUNTRY_CODE)

  const addressValidationSchema = useCreateAddressValidationSchema(CARRIER, countryCode)

  useEffect(() => {
    if (countryCodeState) {
      setCountryCode(countryCodeState)
    }
  }, [countryCodeState])

  const updateAddressValidationSchema = (countryCode: string) => {
    setCountryCode(countryCode)
  }

  return {
    addressValidationSchema,
    updateAddressValidationSchema,
  }
}
